<template>
  <v-dialog v-model="dialog" persistent width="400">
    <v-card>
      <v-card-text class="pt-2">
        <div
          class="mx-auto qj-icon-archive mb-2"
          :class="colorStatus + ' lighten-5'"
        >
          <v-icon x-large :color="colorStatus">{{ iconStatus }}</v-icon>
        </div>
        <h2
          class="font-weight-regular text-xs-center"
          :class="colorStatus + '--text text--lighten-1'"
          style="line-height: initial"
          v-html="textStatus"
        ></h2>
        <v-flex xs12 class="mb-2" v-if="status == 'STIMULATE'">
          <v-layout column>
            <v-switch
              v-model="todayRetroactive"
              color="blue"
              label="Enviar os retroativos de hoje"
              hide-details
            ></v-switch>
            <small v-if="!todayRetroactive" class="mt-2 ml-1 red--text text--darken-1">
              <v-icon small color="red darken-1">mdi-information-outline</v-icon>
              Se esta opção ficar desativada, os preparos do dia serão agendados para o dia seguinte.
            </small>
          </v-layout>
        </v-flex>
        <v-flex v-if="todayRetroactive">
          <span>Retroativo a partir de qual horário?</span>
          <v-select
            label="Horário"
            item-text="text"
            item-value="value"
            box
            :items="allowedTimes"
            v-model="retroactiveTime"
          ></v-select>
        </v-flex>
      </v-card-text>
      <v-card-actions class="px-0 pb-0">
        <v-btn
          dark
          block
          large
          depressed
          class="ma-0 qj-br-0"
          color="grey lighten-1"
          @click="$emit('update:dialog', false)"
        >
          Não
        </v-btn>
        <v-btn
          dark
          block
          large
          depressed
          class="ma-0 qj-br-0"
          :color="colorStatus + ' lighten-1'"
          @click="confirmed"
        >
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  props: ["dialog", "status", "isUnarchive", "treeActiveAt"],
  computed: {
    textStatus() {
      switch (this.status) {
        case "ARCHIVED":
          return "Deseja arquivar essa árvore?";
        case "STIMULATE":
          return "Deseja <b>iniciar</b> os disparos dos estímulo nessa árvore?";
        case "ANALYZABLE":
          return this.isUnarchive
            ? "Deseja desarquivar essa árvore?"
            : "Deseja <b>parar</b> os disparos dos estímulo nessa árvore?";
        default:
          return "";
      }
    },
    colorStatus() {
      return this.status == "ARCHIVED" ? "red" : "blue";
    },
    iconStatus() {
      return this.status == "ARCHIVED"
        ? "mdi-archive-arrow-down-outline"
        : "mdi-information-outline";
    },
  },
  data: () => ({
    retroactiveTime: "08:00:00",
    todayRetroactive: false,
    allowedTimes: [
      { text: "4h", value: "04:00:00" },
      { text: "5h", value: "05:00:00" },
      { text: "6h", value: "06:00:00" },
      { text: "7h", value: "07:00:00" },
      { text: "8h", value: "08:00:00" },
      { text: "9h", value: "09:00:00" },
      { text: "10h", value: "10:00:00" },
      { text: "11h", value: "11:00:00" },
      { text: "12h", value: "12:00:00" },
      { text: "13h", value: "13:00:00" },
      { text: "14h", value: "14:00:00" },
      { text: "15h", value: "15:00:00" },
      { text: "16h", value: "16:00:00" },
      { text: "17h", value: "17:00:00" },
      { text: "18h", value: "18:00:00" },
      { text: "19h", value: "19:00:00" },
    ],
  }),
  methods: {
    confirmed() {
      let activeAt = "";
      if (this.status == "STIMULATE") {
        if (this.todayRetroactive) {
          activeAt = moment().format("YYYY-MM-DD") + "T" + this.retroactiveTime;
        } else {
          activeAt = moment().add(1, "days").format("YYYY-MM-DD") + "T08:00:00";
        }
        this.todayRetroactive = false;
      }
      this.$emit("update:dialog", false);
      this.$emit("confirmed", activeAt ? activeAt : this.treeActiveAt);
    },
  },
};
</script>

<style lang="scss" scoped>
.qj-icon-archive {
  width: 70px;
  border-radius: 50%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qj-br-0 {
  border-radius: 0 !important;
}
</style>
